import Departments from "./Departments";

const themes = [
  {
    accent: "bg-sky-500", accentText: "text-sky-500", accentBorder: "border-sky-500",
    ring: "ring-sky-500/30", cardBorder: "hover:border-sky-400/60",
    badge: "bg-sky-50 text-sky-700 border-sky-200",
    divider: "bg-sky-500", subtleText: "text-stone-400",
    degreeText: "text-sky-600",
  },
  {
    accent: "bg-emerald-500", accentText: "text-emerald-500", accentBorder: "border-emerald-500",
    ring: "ring-emerald-500/30", cardBorder: "hover:border-emerald-400/60",
    badge: "bg-emerald-50 text-emerald-700 border-emerald-200",
    divider: "bg-emerald-500", subtleText: "text-stone-400",
    degreeText: "text-emerald-600",
  },
  {
    accent: "bg-violet-500", accentText: "text-violet-500", accentBorder: "border-violet-500",
    ring: "ring-violet-500/30", cardBorder: "hover:border-violet-400/60",
    badge: "bg-violet-50 text-violet-700 border-violet-200",
    divider: "bg-violet-500", subtleText: "text-stone-400",
    degreeText: "text-violet-600",
  },
  {
    accent: "bg-amber-500", accentText: "text-amber-600", accentBorder: "border-amber-500",
    ring: "ring-amber-500/30", cardBorder: "hover:border-amber-400/60",
    badge: "bg-amber-50 text-amber-700 border-amber-200",
    divider: "bg-amber-500", subtleText: "text-stone-400",
    degreeText: "text-amber-600",
  },
  {
    accent: "bg-rose-500", accentText: "text-rose-500", accentBorder: "border-rose-500",
    ring: "ring-rose-500/30", cardBorder: "hover:border-rose-400/60",
    badge: "bg-rose-50 text-rose-700 border-rose-200",
    divider: "bg-rose-500", subtleText: "text-stone-400",
    degreeText: "text-rose-600",
  },
];

function CollegesComp(props) {
  const data = props.data;
  const theme = themes[props.index % themes.length];

  const renderLogo = () => {
    if (!data.logoUrl) return null;
    return (
      <div className={`rounded-2xl ring-4 ${theme.ring} bg-stone-100 p-4 flex items-center justify-center`}>
        <img
          src={data.logoUrl}
          alt={data.name}
          className="w-full max-w-[200px] object-contain"
        />
      </div>
    );
  };

  return (
    <div className="w-screen flex justify-center bg-white border-b border-stone-100">
      <div className="flex w-full max-w-[1200px] mx-auto flex-col items-center py-14 px-6 md:px-20">
        {/* Accent top bar */}
        <div className={`w-16 h-1.5 ${theme.accent} rounded-full mb-6`} />

        {/* Heading */}
        <div className="flex items-center gap-4 mb-2">
          <span className={`hidden md:block w-1.5 h-10 rounded-full ${theme.accent} flex-shrink-0`} />
          <h2 className="text-3xl md:text-4xl font-extrabold text-center md:text-left text-stone-900">
            {data.name}
          </h2>
        </div>

        {data.shortName && (
          <span className={`mt-2 mb-6 inline-block px-3 py-0.5 rounded-full text-xs font-semibold tracking-widest uppercase border ${theme.badge}`}>
            {data.shortName}
          </span>
        )}

        {/* Logo */}
        {data.logoUrl && (
          <div className="w-[180px] mb-10 flex justify-center">
            {renderLogo()}
          </div>
        )}

        {/* Programs grid — 1 col on mobile, 2 on sm, 3 on lg (capped by count) */}
        <div
          className={`grid gap-4 w-full ${
            data.departments.length === 1
              ? "grid-cols-1 max-w-sm"
              : data.departments.length === 2
              ? "grid-cols-1 sm:grid-cols-2 max-w-2xl"
              : "grid-cols-1 sm:grid-cols-2 lg:grid-cols-3"
          }`}
        >
          {data.departments.map((val, key) => (
            <Departments key={key} data={val} theme={theme} />
          ))}
        </div>
      </div>
    </div>
  );
}

export default CollegesComp;
